import Constant from '@/const';
import axios from 'axios';

const postDiagnose = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/master/diagnose`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postDiagnose;
